import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const SedanCars = () => {
  return (
    <>
      <section
        className="page-title"
       style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Sedan Car Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>Sedan Car Rentals by eTravo</h1>

        <p style={styles.paragraph}>
          At <strong>eTravo</strong>, we offer well-maintained Sedan cars perfect for smooth and stylish urban travel.
          Whether it’s a business trip, local city ride, or airport transfer — our Sedan rental service guarantees 
          comfort, privacy, and a refined driving experience.
        </p>

        <h2 style={styles.subHeader}>Available Sedan Models:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Maruti Suzuki Dzire</strong></li>
          <li style={styles.listItem}><strong>Honda Amaze</strong></li>
          <li style={styles.listItem}><strong>Hyundai Aura</strong></li>
          <li style={styles.listItem}><strong>Toyota Etios</strong></li>
        </ul>

        <h2 style={styles.subHeader}>Ideal For:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Local City Travel</li>
          <li style={styles.listItem}>Daily Office Commute</li>
          <li style={styles.listItem}>Airport Pick-up & Drop</li>
          <li style={styles.listItem}>Business Meetings</li>
          <li style={styles.listItem}>Couple or Solo Travel</li>
        </ul>

        <h2 style={styles.subHeader}>Features You’ll Love:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Comfortable seating for 4 passengers</li>
          <li style={styles.listItem}>AC, music system, clean interiors</li>
          <li style={styles.listItem}>Ample boot space</li>
          <li style={styles.listItem}>Fuel-efficient for long rides</li>
          <li style={styles.listItem}>Professional, uniformed chauffeurs</li>
        </ul>

        <h2 style={styles.subHeader}>Why eTravo?</h2>
        <p style={styles.paragraph}>
          With <strong>eTravo</strong>, you don’t just rent a car — you hire a commitment to quality. We ensure
          on-time service, sanitized vehicles, and courteous drivers. Whether it’s for business or leisure,
          we make sure your ride is smooth, private, and punctual.
        </p>

        <p style={styles.paragraph}>
          Our booking process is simple and quick. You can reserve a Sedan with just a call or a few clicks online.
          Enjoy flexible billing, 24/7 customer support, and premium service at affordable prices.
        </p>

      

        <h2 style={styles.subHeader}>Book Your Sedan Today!</h2>
        <p style={styles.paragraph}>
          Need a clean, comfortable, and reliable car? eTravo has you covered. Book your Sedan now and
          enjoy a peaceful, professional journey backed by a trusted travel brand.
        </p>
      </div>
    </>
  );
};

export default SedanCars;
